import { atom } from 'recoil';

export const occupationsData = atom({
  key: "occupationsData",
  default: null
});